import { z } from 'zod';

export const changeMonthlyPaymentPostRequestSchema = z.object({
  recommended_payment: z.string(),
  reference: z.string(),
});
